var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"raised":"","width":"90%"}},[_c('baseVCalendar',{attrs:{"query":"Web_Planung_Reisen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }